<template>
  <loader v-if="loadingProducts" />
  <div v-else>
    <h5 @click="toggle">{{ i18n.t('/ProductBlocks/Settle/Title') }}</h5>
    <products-block
      v-if="showSettle"
      data-qa="settle-block"
      :products="products"
      :products-categories="categories"
      :selected-products="selectedProducts"
      :can-add-products="false"
      :show-purchase-price="true"
      :products-are-editable="isEditable"
      block-type="Settle"
      @add-to-selected="addToSelected"
      @remove-from-selected="removeFromSelected"
    />
  </div>
</template>

<script>
import ProductsBlock from '@/components/generic/presentational/organisms/productsBlock/ProductsBlock.vue'
import HandleAccessoryEvents from '@/mixins/handleAccessoryEvents.js'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    ProductsBlock,
    Loader,
  },
  mixins: [HandleAccessoryEvents],
  props: {
    startExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      products: [],
      selectedProducts: [],
      showSettle: false,
      loadingProducts: true,
      categories: ['Bonuses', 'NonRecoverableCosts'],
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      quoteStatusIsSalesOrder: 'quote/quoteStatusIsSalesOrder',
      salesOrderSendToAutoline: 'quote/salesOrderSendToAutoline',
    }),

    isEditable() {
      return !this.quoteStatusIsSalesOrder || !this.salesOrderSendToAutoline
    },
  },
  created() {
    this.showSettle = this.startExpanded

    StoreConnector.get('accessories/loading', (data) => {
      this.loadingProducts = data
    })

    StoreConnector.get('quote/accessories', (data) => {
      this.selectedProducts = data.filter((c) => this.isCategory(c) || c.CustomPurchasePrice)
    })

    StoreConnector.getWithParam(
      'accessories/accessoriesWithCategories',
      this.categories,
      (data) => {
        this.products = data
      }
    )
  },
  beforeUnmount() {
    StoreConnector.removeListeners(['accessories/loading', 'quote/accessories'])
  },
  methods: {
    isCategory(product) {
      return this.categories.includes(product.Category)
    },
    toggle() {
      this.showSettle = !this.showSettle
    },
  },
}
</script>
